 
 import React from 'react'
import { useNavigate } from "react-router-dom";
 
 const CTASectionResources = () => {
  const navigate = useNavigate();
 
   return (
     <section className="pb-14 px-6 max-w-6xl mx-auto">
          <div
            className="relative flex flex-col sm:flex-row items-center justify-between gap-6 rounded-2xl overflow-hidden px-6 py-8 sm:px-8"
            style={{ background: '#EFF4FB', border: '0.5px solid #c8d8ec' }}
          >
            {/* Blob — hidden on mobile, visible on sm+ */}
            <div
              className="hidden sm:block absolute left-0 top-0 bottom-0 w-32 pointer-events-none"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 160'%3E%3Cellipse cx='30' cy='70' rx='28' ry='55' fill='%23b8d8f0' opacity='0.55' transform='rotate(-15 30 70)'/%3E%3Cellipse cx='62' cy='110' rx='22' ry='40' fill='%23a8cce8' opacity='0.4' transform='rotate(20 62 110)'/%3E%3Cellipse cx='10' cy='130' rx='18' ry='32' fill='%23c5e0f8' opacity='0.35' transform='rotate(-5 10 130)'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left center',
                backgroundSize: 'contain',
              }}
            />

            {/* Text — no left padding on mobile */}
            <div className="sm:pl-32 flex flex-col gap-2 flex-1 text-center sm:text-left">
              <h3
                className="font-bold"
                style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', color: 'var(--primary-color)' }}
              >
                Ready to take the next step?
              </h3>
              <p
                className="text-xs leading-relaxed"
                style={{ color: 'var(--primary-color)', maxWidth: '380px', margin: '0 auto sm:m-0' }}
              >
                Personalized care, expert support, and real progress — we're here for you.
              </p>
            </div>
            {/* CTA */}
            <div className="flex flex-col items-center gap-2 sm:items-end shrink-0">
              <button onClick={() => navigate('/carejourney')}
                style={{
                  backgroundColor: 'var(--primary-color)',
                  color: 'white',
                  fontSize: 'clamp(0.78rem, 1.2vw, 0.875rem)',
                  padding: 'clamp(0.55rem, 1vw, 0.7rem) clamp(1.2rem, 2.5vw, 1.8rem)',
                }}
                className="rounded-md font-bold shadow-md shadow-blue-200 transition hover:-translate-y-0.5 hover:bg-blue-600"
              >
                Start Care Journey →
              </button>
              <span className="flex items-center gap-1 text-xs primary-text">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                It only takes a few minutes
              </span>
            </div>
          </div>
        </section>
   )
 }
 
 export default CTASectionResources
